"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var appendCss = function appendCss() {
  var cssText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  try {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.append(document.createTextNode(cssText));
    var head = document.querySelectorAll('head')[0];
    head.append(style);
  } catch (error) {
    console.error(error);
  }
};

var screenHasFooterBar = function screenHasFooterBar() {
  var defaultVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var result = false;
  var rate = window.screen.height / window.screen.width;
  var limit = window.screen.height == window.screen.availHeight ? 1.8 : 1.65;

  if (rate > limit) {
    result = true;
  }

  return result;
};

var _default = {
  screenHasFooterBar: screenHasFooterBar,
  appendCss: appendCss
};
exports["default"] = _default;